<template>
  <div class="admin">
    <div class="card-page">
      <div class="card-info">
        <div class="info-card-new">Nasabah Baru</div>
        <div class="value-card-new">{{ dataNew }}</div>
        <i class="fas fa-portrait"></i>
      </div>
      <div class="card-info">
        <div class="info-card-regis">Nasabah Terdaftar</div>
        <div class="value-card-regis">{{ dataAccepted }}</div>
        <i class="fas fa-portrait"></i>
      </div>
      <div class="card-info">
        <div class="info-card-reject">Nasabah Reject</div>
        <div class="value-card-reject">{{ dataReject }}</div>
        <i class="fas fa-portrait"></i>
      </div>
      <div class="card-info">
        <div class="info-card-black">Nasabah Blacklist</div>
        <div class="value-card-black">{{ dataBlock }}</div>
        <i class="fas fa-portrait"></i>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      dataNew: "",
      dataAccepted: "",
      dataReject: "",
      dataBlock: "",
    };
  },
  mounted() {
    let url;
    let role = localStorage.getItem("role");
    if (role == "0") {
      url = "superadmin";
    } else {
      url = "admin-broker";
    }
    axios.get("/v2/" + url + "/kyc/total?status=2").then((res) => {
      this.dataNew = res.data.data.total;
    });
    axios.get("/v2/" + url + "/kyc/total?status=3").then((res) => {
      this.dataAccepted = res.data.data.total;
    });
    axios.get("/v2/" + url + "/kyc/total?status=5").then((res) => {
      this.dataReject = res.data.data.total;
    });
    axios.get("/v2/" + url + "/kyc/total?status=6").then((res) => {
      this.dataBlock = res.data.data.total;
    });
  },
};
</script>

<style scoped>
.card-page {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.card-info {
  width: 220px;
  height: 125px;
  border-radius: 10px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
  margin-top: 35px;
}
.info-card-new,
.info-card-regis,
.info-card-reject,
.info-card-black {
  font-size: 15px;
  color: #ffffff;
  /* background-color: #f5b600; */
  padding: 10px;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  text-align: center;
}
.info-card-new {
  background: #7ed6df;
}
.info-card-regis {
  background: #badc58;
}
.info-card-reject {
  background: #f9ca24;
}
.info-card-black {
  background: #eb4d4b;
}

.value-card-new,
.value-card-regis,
.value-card-reject,
.value-card-black {
  text-align: center;
  font-size: 40px;
  font-weight: bold;
  padding: 8px;
}
.value-card-new {
  color: #7ed6df;
}
.value-card-regis {
  color: #badc58;
}
.value-card-reject {
  color: #f9ca24;
}
.value-card-black {
  color: #eb4d4b;
}
</style>
